/*global define: false */
define('validateUniqueEmail',['jquery', 'validate', 'unobtrusive'], function ($) {
    'use strict';

    $.validator.unobtrusive.adapters.addBool('uniqueemail', 'uniqueEmail');

    $.validator.addMethod('uniqueEmail', function (value, element) {
        var isUnique = false,
            $element = $(element),
            suggestHtml = '<div class="form-tip-below">Did you mean <a href="#" class="did-you-mean">{0}</a>?</div>',
            removeTooltip = function () {
                $element
                    .next('.form-tip-below')
                    .remove();
            };

        if (!value) {
            // allow null value to pass and let server-side
            // validation pick up REQUIRED attribute
            return true;
        }

        $element
            .parent()
            .on('click', '.did-you-mean', function (e) {
                removeTooltip();

                $element
                    .val($(e.target).text())
                    .blur();

                return false;
            });

        $.ajax({
            url: '../../api/account/validateEmail/',
            async: false,
            data: {
                email: value
            },
            success: function (data) {
                isUnique = !(data && data.EmailExists);

                removeTooltip();

                if (data && data.SuggestedEmail) {

                    $element.after(suggestHtml.replace('{0}', data.SuggestedEmail));

                }
            },
            error: function () {
                // an error happend in the JSON service, allow it
                // to pass and let server-side validation pick it up
                isUnique = true;
            }
        });

        return isUnique;
    });
});
